<template>
    <div>
        <p>This is a ZIP archive which comes with script launchers for all supported platforms.
            Java Runtime is not included.</p>

    <div class="p-3">
        <strong>GanttProject {{ version }} for any platform</strong>
        <div class="help-text pb-3">Built on {{ releaseDate }}</div>
        <a role="button" class="btn btn-attention btn-lg" :href="`/dl/${version}/any`" v-on:click="onDownloadStarted" data-track-event="dwnl,dwnl-gp33-zip">Download [{{ size }}]</a>
    </div>
      <h3>Install Java Runtime</h3>
        <p>Java Runtime is NOT included. You have to install it separately.
            GanttProject {{ version }} requires Java Runtime version 17 with JavaFX modules.
            We recommend using <a href="https://bell-sw.com/pages/downloads/#/java-17-lts" target="_blank">
            BellSoft Liberica Java Runtime</a>. Please pay attention that you need to choose <b>Full JRE package</b> in their
          package download options.
        </p>

        <p>There are other vendors who provide Java Runtime with JavaFX, such as
            <a href="https://www.azul.com/downloads/?version=java-17-lts&package=jre-fx#download-openjdk" target="_blank">Zulu from Azul</a>.
          There is also a very convenient tool
            <a href="https://sdkman.io" target="_blank">SDKMAN!</a> for downloading and managing Java runtimes.
          It is Linux-native, but it also works fine on macOS and on Windows with GitHub Shell.
        </p>

      <h3>Maintenance updates</h3>
      <p>Maintenance updates to version {{ version }} will be delivered via our Update Channel.
        Please leave Auto-Update option in the settings switched on to let GanttProject to check for updates from time to time.
        When a new update becomes available, you will be able to review it and choose to install or skip.</p>

    </div>
</template>

<script>
import {gaSendEvent} from "@/components/Analytics";

    export default {
      name: "DownloadZip33",
      props: {
          releaseDate: String,
          size: String,
          version: String,
          virustotalHash: String
      },
      methods: {
          onDownloadStarted: function() {
            gaSendEvent('download_started');
          }
      }
    }
</script>

<style scoped>

</style>
